import { memo } from 'react';

/**
 * ページナビゲーションコンポーネント
 * 前/次ページボタンとページ番号入力
 * ※ memo化により、propsが変更されない限り再レンダリングを防止
 */
const PageNavigation = memo(({
  currentPage,
  totalPages,
  isRendering,
  onPrevPage,
  onNextPage,
  pageInputValue,
  onChangePageInput,
  onPageInputKeyDown,
  onPageInputBlur,
}) => {
  return (
    <div className="pdf-control-group center">
      {/* 前ページボタン */}
      <button
        className="page-nav-button"
        onClick={onPrevPage}
        disabled={currentPage <= 1 || isRendering}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      {/* ページ番号入力/表示 */}
      <div className="page-indicator">
        <input
          type="text"
          value={pageInputValue}
          onChange={onChangePageInput}
          onKeyDown={onPageInputKeyDown}
          onFocus={(e) => e.target.select()}
          onMouseUp={(e) => e.preventDefault()}
          onBlur={onPageInputBlur}
          className="page-input"
          disabled={isRendering}
          inputMode='numeric'
        />
        <span className="page-separator">/</span>
        <span className="total-pages">{totalPages}</span>
      </div>
      {/* 次ページボタン */}
      <button
        className="page-nav-button"
        onClick={onNextPage}
        disabled={currentPage >= totalPages || isRendering}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  );
});

export default PageNavigation;
